window.MDCCartSavingsConfig = {
  excludedSavingsProductIds: ['12602893959486'],
  gifts: [{
    id: 'essential-lampe-cadeau',
    productId: '12627542606142',
    variantId: '54520301977918',
    discountTitle: 'Lampe cadeau offerte',
    additionalDiscountTitles: ['Offre cadeau', 'Cadeau offert avec achat'],
    automaticTitleVerified: true,
    tierId: '1978a3c9-d4c4-46cb-9d1e-1c489ea30ae1',
    currency: 'EUR',
    minimumAmount: 1,
    rulesVerified: true,
    maxQuantity: 1,
    excludedProductIds: ['12591839969598', '12602893959486', '12627542606142']
  }]
};
